<template>
    <div  v-if="attribute.attribute_values && attribute.selected" :class="{'col-lg-12':service.viewPage, 'p-left-0 p-right-0 col-md-12 col-xs-12': true}">
        <span class="attribute-name">{{attribute.attribute_name}}</span>
        <div  v-for="(selected,index) of normalizeSelected(attribute.selected)" :key="attribute.attribute_value_id">
            <div  class="col-md-9 col-xs-9 p-left-0">
                <span class="attribute-value">{{selected.attribute_value}}</span>

            </div>
            <div class="col-md-3 col-xs-3  attribute-value text-right">
                {{selected && selected.unit_price ? '+ '+ priceText(selected.unit_price,selected.cost_type,currency,unit): ''}}
            </div>
            <br>

        </div>
        <hr style="border-top-width: 1px;border-top-style: solid;border-top-color: rgb(218, 222, 226); margin-bottom: 0px;margin-top: 10px">
    </div>
    <div  v-else :class="{'col-lg-12':service.viewPage, 'p-left-0 p-right-0 col-md-12 col-xs-12': true}">
        <span class="attribute-name">{{attribute.attribute_name}}</span>
        <div>
           <div class="col-md-9 col-xs-9 p-left-0">
               <span class="attribute-value">{{attribute.value}}</span>
           </div>
           <div class="col-md-3 col-xs-3  attribute-value text-right">
               {{
                   attribute.value && attribute.unit_price ? '+ ' + priceText(attribute.unit_price, attribute.cost_type, currency, unit) : ''
               }}
           </div>
            <br>
       </div>
        <hr style="border-top-width: 1px;border-top-style: solid;border-top-color: rgb(218, 222, 226); margin-bottom: 0px;margin-top: 10px">
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import {normalizeSelected, priceText} from "@/events/sharedMethods.js";

export default {
    Qname: "customFieldSummaryAttribute",
    props: ['service', 'attribute', 'unit', 'currency'],
    data() {
        return {
            businessType: this.service.businessType ?? null
        }
    },
    methods: {
        priceText, normalizeSelected,
        toggleCollapse(index) {
            this.visits[index].isCollapsed = !this.visits[index].isCollapsed
            $(this.$refs['toggleIcon' + index]).toggleClass('rotate-180')
            this.$forceUpdate()
        },
        getAttributeByAttributeId(attributes, attribute_id) {
            const index = attributes.findIndex(attribute => attribute.attribute_id === attribute_id);
            return attributes[index]
        }


    },
    mounted() {
        EventBus.$on('onBusinessTypeChanged', business_type => {
            this.businessType = business_type
        });
        EventBus.$on('onTodayProcessLoaded', (todayProcessName, todayProcessClass, visit_id) => {
            // let visit = this.visits.filter(visit => visit.multiple_day_id==visit_id)[0]
            // visit.fieldworkerVisitStatus.title_confirmation = todayProcessName
            // visit.fieldworkerVisitStatus.divClass = todayProcessClass
            this.$forceUpdate();
        });
        let businessType = $('#business_address').val();
        if (businessType !== 'mobile' && businessType !== 'virtual') {
            businessType = 'fixed';
        }
        this.businessType = businessType
    },
    watch: {
        attribute: {
            handler(attribute) {
                if (attribute?.selected?.length > 0) {
                    this.$forceUpdate()
                }
            },
            deep: true
        }
    }

}
</script>

<style scoped>

.attribute-name{
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
}
.attribute-value{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}
.rotate-180 {
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
    display: inline-block;
}
.custom-field-summary.summary-container > div:last-child hr {
    display: none;
}
</style>